var _path, _path2, _circle, _path3, _path4, _circle2, _circle3, _circle4, _g, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgePanelist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60L114.092 69.6872L116.396 80.8397L107.571 87.8802L105.963 99.1571L95.3001 102.714L90.0055 112.762L78.7882 112.409L70.4186 120L60.0003 115.756L49.5814 120L41.2118 112.409L29.9938 112.762L24.6999 102.714L14.0365 99.1571L12.4293 87.8795L3.6036 80.8397L5.90754 69.6872L0 60L5.90754 50.3121L3.6036 39.1597L12.4293 32.1198L14.0371 20.8423L24.6999 17.2856L29.9944 7.23784L41.2118 7.59125L49.5814 0L60.0003 4.24352L70.4186 0L78.7882 7.59125L90.0062 7.23784L95.3001 17.2862L105.964 20.8429L107.571 32.1198L116.396 39.1603L114.092 50.3121L120 60Z",
    fill: "#FECC06",
    fillOpacity: 0.39
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9961 108.914C86.6017 108.914 108.17 87.0169 108.17 60.0053C108.17 32.9937 86.6017 11.0965 59.9961 11.0965C33.3904 11.0965 11.8223 32.9937 11.8223 60.0053C11.8223 87.0169 33.3904 108.914 59.9961 108.914Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1011,
    cy: 60.8837,
    r: 29.5992,
    fill: "#FECC06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5547 34.9181C73.134 36.2214 76.3674 38.244 79.0811 40.8106L33.2236 67.2862C32.736 65.2313 32.4766 63.0879 32.4766 60.8839C32.4766 59.2472 32.6186 57.6436 32.8916 56.0851L69.5547 34.9181Z",
    fill: "#FFFC77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9756 45.3967C85.9717 49.814 87.7236 55.1443 87.7236 60.884C87.7236 62.5202 87.5794 64.1228 87.3066 65.6809L50.6436 86.8488C43.8869 84.3881 38.3632 79.365 35.2441 72.9553L82.9756 45.3967Z",
    fill: "#FFFC77"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1006,
    cy: 60.8837,
    r: 21.706,
    fill: "#EE9F07"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1019,
    cy: 60.8837,
    r: 19.7328,
    fill: "#FECC06"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1760_6234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 41,
    width: 40,
    height: 40
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1019,
    cy: 60.8837,
    r: 19.7328,
    fill: "#FECC06"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1760_6234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.474 93.9361L71.4481 58.4171L59.6085 60.8837L53.1953 71.2434L88.7143 106.762L106.474 93.9361Z",
    fill: "#EE9F07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6205 85.5496L60.1016 50.0306V60.8837L95.6205 96.4026V85.5496Z",
    fill: "#EE9F07"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.102 50.0306L63.5816 57.0811L71.4483 58.4171L65.7321 63.6996L67.0084 71.2434L60.102 67.7901L53.1955 71.2434L54.4719 63.6996L48.8418 58.2116L56.6224 57.0811L60.102 50.0306Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0879 30.9181C93.8623 38.1095 98.7415 48.4719 98.7415 59.9914C98.7415 66.7984 97.0378 73.2011 94.0396 78.7847",
    stroke: "#2D3962",
    strokeWidth: 4.20808,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2141 30.9181C25.4397 38.1095 20.5605 48.4719 20.5605 59.9914C20.5605 66.7984 22.2642 73.2011 25.2624 78.7847",
    stroke: "#2D3962",
    strokeWidth: 4.20808,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgePanelist);
export default __webpack_public_path__ + "static/media/badge-panelist.28254a98e71cf64a51c04f11bb7c3324.svg";
export { ForwardRef as ReactComponent };